import { EnquiryTypes } from "./Types/Enquiry";

const getFranchiseEnquiries = (data = null) => {
	return {
		type: EnquiryTypes.GET_FRANCHISE_DETAILS,
		payload: data,
		success: EnquiryTypes.GET_FRANCHISE_DETAILS_SUCCESS,
	};
};

const createNewFranchiseEnquiry = (data = null) => {
	return {
		type: EnquiryTypes.CREATE_FRANCHISE_ENQUIRY,
		payload: data,
		success: EnquiryTypes.CREATE_FRANCHISE_ENQUIRY_SUCCESS,
	};
};

const getContactUsInfo = (data = null) => {
	return {
		type: EnquiryTypes.GET_CONTACT_US_DETAILS,
		payload: data,
		success: EnquiryTypes.GET_CONTACT_US_DETAILS_SUCCESS,
	};
};

const createNewContactUs = (data = null) => {
	return {
		type: EnquiryTypes.CREATE_CONTACT_US,
		payload: data,
		success: EnquiryTypes.CREATE_CONTACT_US_SUCCESS,
	};
};

const createNewFeedback = (data = null) => {
	return {
		type: EnquiryTypes.CREATE_FEEDBACK,
		payload: data,
		success: EnquiryTypes.CREATE_FEEDBACK_SUCCESS,
	};
};

const getFeedback = (data = null) => {
	return {
		type: EnquiryTypes.GET_FEEDBACKS,
		payload: data,
		success: EnquiryTypes.GET_FEEDBACKS_SUCCESS,
	};
};

const failed = (data) => {
	return {
		type: EnquiryTypes.ENQUIRE_ERROR,
		payload: data,
	};
};

export {
	getFranchiseEnquiries,
	createNewFranchiseEnquiry,
	getContactUsInfo,
	createNewContactUs,
	createNewFeedback,
	getFeedback,
	failed,
};
